<template>
  <div class="form-group checkboxes-group v-stack gap-2">
    <input type="text" class="checkboxes-group__search form-control" placeholder="" v-model="search.query"
           v-if="enableSearch">

    <div class="checkboxes-group__info" v-if="filteredOptions.length">
      <div class="checkboxes-group__select-all" v-if="enableSelectAll">
        <button type="button" class="btn btn-link p-0" @click="selectAll">
          {{ this.state.allSelected ? Drupal.t("Clear all") : Drupal.t("Select all") }}
        </button>
      </div>

      <div class="checkboxes-group__selected" v-if="enableSelectedCount">
        {{ Drupal.t("@count selected", {"@count": value.length}) }}
      </div>
    </div>

    <div class="checkbox v-stack gap-1" v-if="filteredOptions.length">
      <Checkbox
        v-for="option in filteredOptions"
        :checked="value.includes(option.id)"
        @update:checked="onCheck(option.id, $event)"
        :id="[name, option.id].join('_')"
        :name="name"
        :label="option.label"
        :key="option"
      />
    </div>

    <div v-else>
      {{ Drupal.t("No matching items") }}
    </div>
  </div>
</template>

<script>
import Checkbox from "./Checkbox.vue";

export default {
  name: "CheckboxGroup",
  emits: ["update:value"],
  components: {
    Checkbox,
  },
  props: {
    name: {
      value: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    options: {
      type: Array,
      required: true,
      validator: (value) => {
        const hasLabelKey = value.every((option) =>
          Object.keys(option).includes("label")
        );
        const hasIdKey = value.every((option) =>
          Object.keys(option).includes("id")
        );
        return hasLabelKey && hasIdKey;
      },
    },
    enableSearch: {
      type: Boolean,
      required: false,
      default() {
        return true
      }
    },
    enableSelectAll: {
      type: Boolean,
      required: false,
      default() {
        return true
      }
    },
    enableSelectedCount: {
      type: Boolean,
      required: false,
      default() {
        return false
      }
    },
  },
  data() {
    return {
      state: {
        allSelected: false,
      },
      search: {
        query: ""
      },
      config: {},
      model: this.value || [],
      Drupal: this.$drupal,
    }
  },
  computed: {
    filteredOptions() {
      return this.options.filter(item => {
        return item.label.toLowerCase().includes(this.search.query.toLowerCase())
      })
    }
  },
  methods: {
    onCheck(optionId, checked) {
      this.model = [...this.value]
      if (checked) {
        this.model.push(optionId)
      } else {
        this.model.splice(this.model.indexOf(optionId), 1)
      }

      this.$emit("update:value", this.model)
    },
    selectAll() {
      this.model = []

      if (!this.state.allSelected) {
        for (const optionKey in this.filteredOptions) {
          this.model.push(this.filteredOptions[optionKey].id)
        }

        this.state.allSelected = true
      } else {
        this.state.allSelected = false
      }

      this.$emit("update:value", this.model)
    },
  }
};
</script>
